export default "__VITE_ASSET__3ff66f2a__"